export enum UploadState {
  UPLOAD_REQUIRED = 'UPLOAD_REQUIRED',
  UPLOADING = 'UPLOADING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export interface Document {
  id: string;
  fileName: string;
  mediaType: string;
  sizeInBytes: number;
  documentTypeKey: string;
  carrierAccountKey: string | null;
  manualUploadState: UploadState | null;
}
